function validateMyForm() {
    // The field is empty, submit the form.
    if (!document.getElementById("__king").value && !document.getElementById("agreetermsandconditions").checked) {
        return true;
    }
    // the field has a value it's a spam bot
    else {
        return false;
    }
}
function hideKing() {
    document.getElementById('__king').style.visibility = 'hidden';
    document.getElementById('__king').removeAttribute("required");
}
function load() {
    setTimeout(hideKing, 2000);
}
window.onload = load;